import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-rate",
  "use": "icon-rate-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-rate\"><defs><style type=\"text/css\"></style></defs><path d=\"M499.2 92.16h-51.2v76.8c-186.88 20.48-332.8 179.2-332.8 371.2 0 204.8 166.4 371.2 371.2 371.2 151.04 0 281.6-89.6 337.92-220.16l58.88 15.36c28.16-46.08 51.2-110.08 51.2-189.44 0-235.52-204.8-424.96-435.2-424.96z m-12.8 768c-176.64 0-320-143.36-320-320 0-161.28 125.44-296.96 281.6-320V563.2l325.12 112.64c-43.52 110.08-166.4 184.32-286.72 184.32z m360.96-215.04l-348.16-117.76v-384c199.68 0 381.44 171.52 381.44 373.76 0 51.2-12.8 92.16-33.28 128z\" p-id=\"8994\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/rate.svg
// module id = h/JX
// module chunks = 31